const CLEAR_ERRORS = 'CLEAR_ERRORS';

export default CLEAR_ERRORS;
